export default __webpack_public_path__ + "static/media/icons8-attach.4550fe30.svg";